var _g, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "100%"
    },
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    id: "svg10510095899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.334 8.333)",
    id: "ss10510095899_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 83.333 41.667 C 83.333 18.655 64.678 0 41.667 0 C 18.655 0 0 18.655 0 41.667 C 0 64.679 18.655 83.334 41.667 83.334 C 45.174 83.334 50 83.818 50 79.167 C 50 76.629 48.68 74.672 47.37 72.727 C 45.45 69.881 43.551 67.064 45.833 62.5 C 48.611 56.945 53.241 56.945 60.34 56.945 C 63.89 56.945 68.056 56.945 72.917 56.25 C 81.671 55 83.333 49.619 83.333 41.667 Z",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.832 54.177 L 20.868 54.167",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.25 33.334 C 34.702 33.334 37.5 30.536 37.5 27.084 C 37.5 23.632 34.702 20.834 31.25 20.834 C 27.798 20.834 25 23.632 25 27.084 C 25 30.536 27.798 33.334 31.25 33.334 Z M 60.416 37.5 C 63.868 37.5 66.666 34.702 66.666 31.25 C 66.666 27.798 63.868 25 60.416 25 C 56.964 25 54.166 27.798 54.166 31.25 C 54.166 34.702 56.964 37.5 60.416 37.5 Z",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    fillOpacity: 0
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#svg10510095899"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmd);
export default __webpack_public_path__ + "static/media/smd.6b3534e7a583744cf26c4b4a29135ebc.svg";
export { ForwardRef as ReactComponent };